import React from 'react';
import web_img from '../images/web.svg';
import app_img from '../images/app.svg';
import custom_software_development from '../images/custom_software_development.svg';
import hosting from '../images/hosting.svg';
import consultation from '../images/consultation.svg';
import digital_marketing from '../images/digital-marketing.svg';
const Services = () => {
    const services = [
        {
            eyebrow: "Product build",
            title: "SaaS Product Development",
            text: "Design and build subscription platforms, portals, dashboards, admin systems, and workflow-heavy products with scalable architecture.",
            outcome: "MVP to production scale",
            image: web_img,
            alt: "SaaS product development"
        },
        {
            eyebrow: "Business systems",
            title: "Enterprise Web Applications",
            text: "Build secure web applications for internal teams, customers, operations, reporting, approvals, and cross-department workflows.",
            outcome: "Reliable operational software",
            image: app_img,
            alt: "Enterprise application development"
        },
        {
            eyebrow: "Automation",
            title: "AI Workflow Automation",
            text: "Turn manual processes into structured digital workflows using intelligent assistants, integrations, rules, and data-driven automation.",
            outcome: "Less manual work, faster decisions",
            image: custom_software_development,
            alt: "AI workflow automation"
        },
        {
            eyebrow: "Modernization",
            title: "Legacy System Modernization",
            text: "Upgrade aging Angular, Node.js, .NET, database, and monolithic systems into cleaner, maintainable, cloud-ready products.",
            outcome: "Lower risk technical renewal",
            image: hosting,
            alt: "Legacy system modernization"
        },
        {
            eyebrow: "Architecture",
            title: "Cloud & API Engineering",
            text: "Plan and implement secure APIs, integrations, cloud deployments, CI/CD pipelines, monitoring, and production release practices.",
            outcome: "Stable systems ready to scale",
            image: consultation,
            alt: "Cloud and API engineering"
        },
        {
            eyebrow: "Long-term support",
            title: "Product Maintenance & Scaling",
            text: "Improve performance, reduce bugs, stabilize releases, add features, and keep existing products moving without rebuilding from scratch.",
            outcome: "Continuous improvement",
            image: digital_marketing,
            alt: "Product maintenance and scaling"
        }
    ];

    return (
        <section id="services" className="services-section services-lean py-5">
            <div className="container" data-aos="fade-up">
                <div className="row g-4 align-items-start">
                    <div className="col-lg-4">
                        <div className="section-intro-sticky">
                            <span className="section-kicker">Services</span>
                            <h2 className="section-title fw-bold text-start">Services built around product outcomes.</h2>
                            <p className="section-subtitle text-muted text-start mb-0">
                                Anmatics helps companies build, modernize, automate, and scale software with clear ownership and production-ready engineering.
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <div className="lean-service-list">
                            {services.map((service, idx) => (
                                <div className="lean-service-item" key={service.title}>
                                    <div className="lean-service-index">{String(idx + 1).padStart(2, '0')}</div>
                                    <img
                                        alt={`${service.alt} illustration`}
                                        src={service.image}
                                        className="lean-service-icon"
                                        width="54"
                                        height="54"
                                        loading="lazy"
                                        decoding="async"
                                    />
                                    <div>
                                        <span className="service-eyebrow">{service.eyebrow}</span>
                                        <h3 className="service-heading mb-2">{service.title}</h3>
                                        <p className="text-muted mb-0">{service.text}</p>
                                        <strong className="service-outcome">{service.outcome}</strong>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="services-action-panel">
                            <div>
                                <span className="section-kicker">Need engineering clarity?</span>
                                <h3 className="fw-bold mb-1">Choose the right next step for your product.</h3>
                                <p className="text-muted mb-0">
                                    Whether you are launching a SaaS platform or improving an existing system, we can help define the technical path.
                                </p>
                            </div>
                            <div className="services-action-buttons">
                                <a href="#contact" className="btn btn-gradient rounded-pill">
                                    Build Your SaaS Platform
                                </a>
                                <a href="#contact" className="btn btn-secondary-brand rounded-pill">
                                    Modernize Your System
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Services;
